import { Component } from '@angular/core';
import {authActions} from "../../../state/auth/auth.actions";
import {Store} from "@ngrx/store";
import * as routeSelectors from "../../../state/route/route.selector";
import {Router} from "@angular/router";

@Component({
  selector: 'google-auth-server-response-validator',
  standalone: true,
  imports: [],
  templateUrl: './google-auth-server-response-validator.component.html',
  styleUrl: './google-auth-server-response-validator.component.scss'
})
export class GoogleAuthServerResponseValidatorComponent {

  redirectUrl: string = "/"

  constructor(
      private store: Store,
      private router: Router
  ) {

    this.store
        .select(routeSelectors.selectQueryParams)
        .subscribe((params) => {
          if (!params) return
          if ("redirect" in params) {
            // Unlikely that google auth supports query params. Not going to handle
            this.redirectUrl = params["redirect"]
          }
          if ("token" in params) {
            this.loginSuccess(params["token"])
          }
        })
  }

  loginSuccess(access_token: string) {
    this.store.dispatch(authActions.loginSucceeded({
      auth: {
        token: {
          access_token: access_token,
          token_type: "jwt"
        },
        userId: ""
      },
      returnUrl: this.redirectUrl
    }))
    this.redirectUrl = "/"
  }
}
